import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { getInitials } from '@/lib/format'

interface AvatarProps {
    src: string | null
    alt?: string | null
    name: string
    className?: string
}

// Leave alt empty when the person's name is already written next to the picture.
export const Avatar: FC<AvatarProps> = ({ src, alt = null, name, className }): ReactNode => {
    if (!src) {
        return (
            <span
                aria-hidden='true'
                className={cn('inline-flex shrink-0 items-center justify-center rounded-full bg-accent font-heading font-medium text-foreground/70', className)}
            >
                {getInitials(name)}
            </span>
        )
    }

    return (
        <img
            src={src}
            alt={alt ?? ''}
            loading='lazy'
            decoding='async'
            className={cn('shrink-0 rounded-full bg-muted object-cover object-[50%_25%]', className)}
        />
    )
}
